// Toggle the menu open and close when on mobile
export default function menuOpen() {
    const nav = document.querySelector('.site-nav');
    const toggle = document.querySelector('.site-nav__toggle');

    if (nav && toggle) {
    toggle.addEventListener('click', () => {
        const isOpen = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(isOpen));
        toggle.setAttribute('aria-label', isOpen ? 'Close navigation menu' : 'Open navigation menu');
    });

    // Restore the desktop navigation if the viewport crosses the breakpoint.
    window.matchMedia('(min-width: 980px)').addEventListener('change', event => {
        if (event.matches) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open navigation menu');
        }
    });
    }
}